import ReferenceIcon from './ReferenceIcon';
import { ChevronDown } from 'lucide-react';
import React from 'react';
import SettingsDialog from './SettingsDialog';

const scoreRows = [
  ['2 harf', '1 puan'],
  ['3 harf', '3 puan'],
  ['4 harf', '6 puan'],
  ['5 harf', '10 puan'],
  ['6 harf', '15 puan'],
  ['7 harf', '21 puan'],
  ['8 harf', '28 puan'],
  ['9 harf', '36 puan'],
  ['10 harf', '45 puan'],
];

export default function GameRulesModal({ onClose }) {
  return (
    <SettingsDialog title="Kurallar" onClose={onClose}>
        <div className="space-y-5 px-5 py-5 text-sm leading-6 text-gray-700 sm:text-base">
          <details className="rounded-xl bg-white p-3 ring-1 ring-slate-200">
            <summary className="reference-accordion"><ReferenceIcon kind="target"/><span>Amaç</span><ChevronDown size={18}/></summary>
            <p>Her oyuncunun kendi seçilen 5×5, 7×7, 9×9 veya 10×10 tahtası vardır. Hem seçtiğin harfleri hem de rakibinden gelen harfleri kullanarak yatay ve dikey geçerli Türkçe kelimeler oluşturursun. Uzun kelimeler daha çok puan getirir; oyun sonunda en yüksek puanı alan kazanır. Eşit puan beraberliktir.</p>
          </details>

          <details className="rounded-xl bg-white p-3 ring-1 ring-slate-200">
            <summary className="reference-accordion"><ReferenceIcon kind="rules"/><span>Bir tur nasıl oynanır?</span><ChevronDown size={18}/></summary>
            <ol className="mt-1 list-decimal space-y-1 pl-5">
              <li>Rakibinden gelen harfi kendi tahtandaki boş bir hücreye yerleştirirsin. Harfi değiştiremezsin; yalnızca yerini seçersin.</li>
              <li>Sonra kendi harfini seçip boş bir hücreye koyarsın. Seçtiğin aynı harf rakibine gönderilir ve sıra ona geçer.</li>
            </ol>
            <p className="mt-2">Oyuna başlayan oyuncuya ilk turda rakip harfi gelmez; doğrudan kendi harfini seçer.</p>
          </details>

          <details className="rounded-xl bg-white p-3 ring-1 ring-slate-200">
            <summary className="reference-accordion"><ReferenceIcon kind="refresh"/><span>Pas</span><ChevronDown size={18}/></summary>
            <p>Rakipten gelen harfi yerleştirmek yerine pas geçebilirsin. Bu harf kalıcı olarak kaybolur ve tahtanda o yerleşim eksik kalır. Pasın ayrıca puan cezası yoktur ve kalan süreyi yenilemez. Kendi harfini koyma aşamasında pas yoktur.</p>
          </details>

          <details className="rounded-xl bg-white p-3 ring-1 ring-slate-200">
            <summary className="reference-accordion"><ReferenceIcon kind="tiles"/><span>Kelime ve puanlama</span><ChevronDown size={18}/></summary>
            <p>Kesintisiz yatay ve dikey kelimeler puan getirir. Çapraz kelimeler sayılmaz.</p>
            <div className="reference-score-table mt-3 grid grid-cols-2 overflow-hidden rounded-xl border border-gray-200 text-center">
              <b>Harf</b><b>Puan</b>{scoreRows.map(([length, score]) => (
                <React.Fragment key={length}>
                  <div className="border-b border-r border-gray-100 px-3 py-2 font-medium last:border-b-0">{length.split(' ')[0]}</div>
                  <div className="border-b border-gray-100 px-3 py-2 font-bold text-indigo-700 last:border-b-0">{score.split(' ')[0]}</div>
                </React.Fragment>
              ))}
            </div>
            <p className="reference-info">Maçın başladığı sözlük sürümü geçerlidir.</p>
            <button onClick={onClose} className="rules-understood">Anladım</button>
            <details className="rules-explanation"><summary>Sözlük ve renk ayrıntıları</summary>
            <p>Geçerli kelime maçın başladığı sözlük sürümünde bulunmalıdır. Sonraki sözlük güncellemeleri eski maça uygulanmaz. Anlam eksikliği kelimenin geçersiz olduğu anlamına gelmez. Aynı harflerin içindeki daha kısa kelimeler, daha uzun geçerli kelimeyle üst üste puanlanmaz.</p>
            <div className="mt-2 space-y-1 rounded-xl bg-gray-50 p-3 text-sm">
              <p><span className="font-bold text-green-600">Yeşil çerçeve:</span> Harf, puan alan geçerli bir kelimenin parçasıdır.</p>
              <p><span className="font-bold text-red-600">Kırmızı çerçeve:</span> Onaylanmış harf henüz puan alan bir kelimenin parçası değildir.</p>
            </div>
            </details>
          </details>

          <details className="rounded-xl bg-white p-3 ring-1 ring-slate-200">
            <summary className="reference-accordion"><ReferenceIcon kind="time"/><span>Süre ve oyun sonu</span><ChevronDown size={18}/></summary>
            <p>Yeni maçlarda oyuncu başına toplam 10+0 dakika, 30+0 dakika veya 12 saat seçilir. Yalnızca sırası gelen oyuncunun saati işler; tur değişince kalan süre korunur, ek süre verilmez. Toplam süre dolarsa aktif oyuncu maçı kaybeder. Eski maçlarda tur başına 12 saat veya 72 saat kuralı korunur. Yerleşim hakkı tamamlandığında (paslar dahil) veya iki tahta dolduğunda maç biter. Normal bitişte yüksek puan kazanır. Süre dolması ve pes etme, puan üstünlüğünden bağımsız yenilgidir. Davet kabul edilince saat hemen başlar; çevrimdışı kalmak saati durdurmaz.</p>
          </details>
        </div>

    </SettingsDialog>
  );
}
